export default __webpack_public_path__ + "decea68da3fe95d22ca7cc678f5852f6.png";